/** Force the document viewport to the top (main + html/body for mobile Safari). */
export function resetWindowScroll() {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

/**
 * Re-apply scroll reset after layout/paint — helps when content height changes
 * (e.g. product detail skeleton → full page) and the browser preserves scroll.
 */
export function resetWindowScrollAfterPaint() {
  resetWindowScroll();
  requestAnimationFrame(() => {
    resetWindowScroll();
    requestAnimationFrame(resetWindowScroll);
  });
}
